import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { Modal, Button } from '@bingads-webui-react/primitive';
import { TaxDialogStyles } from '../styles/tax-dialog';

const UnthemedConfirmTaxCertificateDialog = ({
  onConfirmClick,
  onGoBackClick,
  show,
  i18n,
  classes,
  isRejection,
}) => {
  const titleI18nKey = isRejection
    ? _TL_('Confirm a rejection of the tax certificate')
    : _TL_('Confirm an approval of the tax certificate');
  const contentI18nKey = isRejection
    ? _TL_('Once you reject the tax certificate, please respond to the CSS ticket with the validation result and reasoning so that the customer can be informed. It is not a reversable decision. Please click "Confirm" if you decide to proceed.')
    : _TL_('Once you approve the tax certificate, please respond to the CSS ticket with the validation result so that the customer can be informed. It is not a reversable decision so make sure that TTR Managed Services has validated and approved the certificate too. Please click "Confirm" if you decide to proceed.');

  return (
    <Modal show={show} backdrop="static" className="confirm-tax-certificate-lightbox">
      <Modal.Header className={classes.modalHeader}>
        <Modal.Title>{i18n.getString(titleI18nKey)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={`confirm-tax-certificate-lightbox-content ${classes.modalContent}`}>
          {i18n.getString(contentI18nKey)}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="confirm-tax-certificate-lightbox-confirm-btn btn-primary" onClick={onConfirmClick}>{i18n.getString(_TL_('Confirm'))}</Button>
        <Button className="confirm-tax-certificate-lightbox-go-back-btn" onClick={onGoBackClick}>{i18n.getString(_TL_('Go back'))}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export const ConfirmTaxCertificateDialog = injectSheet(TaxDialogStyles.CommonTaxDialog)(UnthemedConfirmTaxCertificateDialog);

UnthemedConfirmTaxCertificateDialog.propTypes = {
  onConfirmClick: PropTypes.func.isRequired,
  onGoBackClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
  isRejection: PropTypes.bool,
};

UnthemedConfirmTaxCertificateDialog.defaultProps = {
  isRejection: false,
};
